import React from "react"
import PropTypes from "prop-types"
import lockHelper from "src/components/Calendar/Header/lockHelper"
import { PrimaryButton } from "@infotech/uikit-button"

import { Box } from "src/components/Grid"
import get from "lodash/get"
import {
  PlanTasksIcon,
  CalendarIcon,
  LockedIcon,
  SearchIcon,
} from "@infotech/uikit-icons"
import styles from "./styles.css"

const FirstCreationFiller = ({
  onAdd,
  inPlan,
  isPlanLocked,
  plan,
  resourceNameFilter,
  filterCalendarBy,
  togglePlanLock,
}) => {
  const { setResourceNameFilter } = filterCalendarBy
  const getEmptyCalendarConfig = () => {
    const iconProps = {
      size: `large`,
      color: `#edf2f7`,
      className: styles.Icon,
    }
    if (typeof resourceNameFilter === `string`) {
      return {
        icon: <SearchIcon {...iconProps} />,
        header: `Ресурсов не найдено`,
        text: `По результатам поиска ресурсов не найдено`,
        buttonText: `Сбросить поиск`,
        buttonAction: () => setResourceNameFilter(null),
      }
    }
    if (inPlan) {
      if (isPlanLocked) {
        return {
          icon: <LockedIcon {...iconProps} />,
          header: `План заблокирован`,
          text: `Для начала работы с планом,  разблокируйте его.`,
          buttonText: `Разблокировать`,
          buttonAction: () =>
            lockHelper({
              planUuids: get(plan, `data.uuid`),
              isLocked: get(plan, `data.locked`),
              toggle: togglePlanLock,
            }),
        }
      }
      return {
        icon: <PlanTasksIcon {...iconProps} />,
        header: `Начало работы с планом`,
        text: `Для работы с планом, создайте новые события или добавьте их из календаря.`,
        buttonText: `Создать событие`,
        buttonAction: onAdd,
      }
    }
    return {
      icon: <CalendarIcon {...iconProps} />,
      header: `Начало работы с календарем`,
      text: `Для работы с календарем, создайте новые события.`,
      buttonText: `Создать событие`,
      buttonAction: onAdd,
    }
  }

  const {
    icon,
    header,
    text,
    buttonText,
    buttonAction,
  } = getEmptyCalendarConfig()

  return (
    <Box className={styles.PlanEmptyOverlay} pb="1md">
      <Box loose flex column className={styles.ContentWrapper}>
        <Box loose>{icon}</Box>
        <Box loose className={styles.Header}>
          {header}
        </Box>
        <Box loose className={styles.Text} pt="1md">
          {text}
        </Box>
        <Box loose pt="2md">
          <PrimaryButton onClick={buttonAction}>{buttonText}</PrimaryButton>
        </Box>
      </Box>
    </Box>
  )
}

FirstCreationFiller.propTypes = {
  onAdd: PropTypes.func.isRequired,
  inPlan: PropTypes.bool.isRequired,
  isPlanLocked: PropTypes.bool.isRequired,
  togglePlanLock: PropTypes.func.isRequired,
  plan: PropTypes.shape({
    data: PropTypes.shape({
      uuid: PropTypes.string,
      locked: PropTypes.bool,
    }),
  }).isRequired,
}

export default FirstCreationFiller
